var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 14,
    viewBox: "0 0 24 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22,4a1.992,1.992,0,0,1-.652-.118L16.909,7.435A2,2,0,1,1,13,8c0-.011,0-.02,0-.031L9.438,6.384A1.992,1.992,0,0,1,8,7a1.926,1.926,0,0,1-.276-.028l-3.867,4.3A1.979,1.979,0,0,1,4,12a2,2,0,1,1-2-2,1.871,1.871,0,0,1,.282.029L6.145,5.737A1.993,1.993,0,1,1,9.9,4.4l4.157,1.847A1.977,1.977,0,0,1,15,6a2.023,2.023,0,0,1,.436.051l4.6-3.682A2.042,2.042,0,0,1,20,2a2,2,0,1,1,2,2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.6a99eeafea8d0585ea94b30be102c865.svg";
export { ForwardRef as ReactComponent };